import { SectionStubDto } from 'models/dtoTypes';

interface SectionMenuItem {
  alias: string;
  path: string;
  label: string;
  lock: boolean;
  color: string;
}

const getColor = (sectionResponseState: string | undefined): string => {
  switch (sectionResponseState) {
    case 'Partial':
      return '#ffe059';
    case 'Completed':
      return '#01820c';
    default:
      return '#cccecc';
  }
};

const generateSectionMenu = (
  sections: SectionStubDto[],
  section: SectionStubDto,
): SectionMenuItem => {
  const { alias = '', label, sectionResponseState } = section; // prerequisiteSections
  // const conditionStates = Array.isArray(prerequisiteSections) && prerequisiteSections.length > 0
  //   ? sections
  //     .filter(s => prerequisiteSections.includes(s.alias || ''))
  //     .map(s => s.sectionResponseState)
  //   : [];
  // https://coriolistechnologies.atlassian.net/browse/KOS-1362
  // Do not lock
  // const anyNotComplete = Boolean(conditionStates.find(s => s !== 'Completed'));
  // console.log(anyNotComplete);

  return {
    alias,
    path: `/questionnaire/${alias}`,
    label: label || 'Unknown',
    color: getColor(sectionResponseState),
    lock: false,
  };
};

export const generateSectionMenus = (sections: SectionStubDto[]): SectionMenuItem[] =>
  sections.map((section) => generateSectionMenu(sections, section));
